import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { chessCamera_shaker } from '../chessCamera_shaker-sidecar'
import { chessPieces } from '../chessPieces-sidecar'
import { EChessPieceType } from '../chessPiecesData'
import { chessSounds } from '../sound/chessSounds-sidecar'
import { EChessMessage } from './chessMessageIds'

export interface IChessMessagePieceCreate {
  pieceId: number
}

export const messageId = EChessMessage.PieceKill

export function write(m: IMessageWriter, d: IChessMessagePieceCreate) {
  messageWriter.write8(m, messageId)
  messageWriter.write32(m, d.pieceId)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IChessMessagePieceCreate = {
    pieceId: messageWriter.read32(m),
  }

  return d
}

export function test() {
  let ex: IChessMessagePieceCreate = {
    pieceId: 100,
  }
  messageWriter.test('piece-kill', ex, write, read)
}

export function process(m: IMessageWriter, isFromHost: boolean) {
  let msg = read(m)
  if (websockets.testRequiredFromHost(isFromHost, m, messageId)) {
    return
  }

  let cp = chessPieces.findByIdSafe(msg.pieceId)

  if (cp && !cp.isDead) {
    if (cp.type === EChessPieceType.Queen) {
      chessCamera_shaker.shake(0.5, 1)
    }
    if (cp.type === EChessPieceType.King) {
      chessCamera_shaker.shake(1, 1.5)
    }
    chessPieces.createRocks(cp, true)
    chessPieces.kill(cp)
    chessSounds.playPieceKill()
  }
}

export function sendMessageAndImmediatelyExecute(
  msg: IChessMessagePieceCreate,
) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
